<template id="notfoundTmpl" >
	<h1>Page not found</h1>
</template>
<script>
module.exports = {
  
};
</script>